const CARDS = [
  {
    title: '2026暑期观影指南',
    desc: '暑假看什么？这份片单帮你选。从院线新片到经典老片，动作科幻喜剧动画全收录，高清流畅在线看。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20setup%20with%20projector%20screen%20and%20cozy%20blankets%2C%20warm%20evening%20light%2C%20popcorn%20in%20wooden%20bowl%2C%20cinematic%20atmosphere%2C%20artistic%20photography%2C%20rich%20amber%20and%20cream%20tones&width=800&height=560&seq=cards-01&orientation=landscape',
    tag: '观影指南',
  },
  {
    title: '豆瓣9分以上华语剧',
    desc: '口碑炸裂的国产剧天花板合集。从年代剧到悬疑剧，每一部都是现象级作品，值得反复品味。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20still%20with%20vintage%20aesthetic%20and%20warm%20lighting%2C%20traditional%20Chinese%20street%20scene%20at%20dusk%2C%20nostalgic%20cinematic%20mood%2C%20artistic%20film%20poster%20style%2C%20rich%20amber%20and%20sepia%20tones&width=800&height=560&seq=cards-02&orientation=landscape',
    tag: '高分华语',
  },
  {
    title: '不敢一个人看的恐怖片',
    desc: '精选高分恐怖惊悚佳作，氛围营造一流，剧情反转惊人。建议白天观看，胆小者请开灯。',
    img: 'https://readdy.ai/api/search-image?query=Atmospheric%20horror%20movie%20scene%20with%20old%20house%20and%20fog%2C%20dim%20warm%20candlelight%2C%20cinematic%20suspense%20mood%2C%20artistic%20composition%2C%20rich%20sepia%20and%20deep%20amber%20shadows%2C%20film%20poster%20aesthetic&width=800&height=560&seq=cards-03&orientation=landscape',
    tag: '恐怖惊悚',
  },
  {
    title: '治愈系电影精选',
    desc: '累了倦了？这些温暖治愈的电影最适合窝在被窝里看。让好故事抚慰你的心情，给生活加点糖。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20warm%20blankets%20and%20soft%20cushions%20near%20sunny%20window%2C%20cat%20sleeping%20peacefully%2C%20warm%20golden%20hour%20light%2C%20comforting%20atmosphere%2C%20artistic%20photography%2C%20rich%20cream%20and%20soft%20amber%20tones&width=800&height=560&seq=cards-04&orientation=landscape',
    tag: '治愈推荐',
  },
  {
    title: '大导演作品合集',
    desc: '诺兰、王家卫、是枝裕和、奉俊昊……世界顶级导演的代表作一次看完，感受电影大师的独特魅力。',
    img: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%20with%20vintage%20cameras%20and%20warm%20studio%20lights%2C%20cinematic%20behind%20the%20scenes%20atmosphere%2C%20artistic%20composition%2C%20rich%20golden%20and%20warm%20brown%20tones&width=800&height=560&seq=cards-05&orientation=landscape',
    tag: '大师作品',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            精选合集
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            专题影视合集
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按主题精选好片，发现更多观影乐趣
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CARDS.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {CARDS.slice(3, 5).map((item, i) => (
            <a
              key={i + 3}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}